import React from 'react'
import glamorous, { Img, Div, Span } from 'glamorous'
import {dimensions, box, spacing, type, textColor, borders, leading, color } from '../../../style';
import { tsDate, tsDiff } from '../../../common'

const Date = glamorous.div(
  {
    textAlign: 'center',
  }
)

const Range = glamorous.div(
  {
    display: 'flex',
    justifyContent: 'center'
  }
)

const DateSep = glamorous.div(
  {
    width: 80,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  }
)

/**
 * Functional Compoent to render the Date Blocks based on a given timestamp
 * @param {String} timestamp timestamp from the API
 */
const renderDate = (timestamp) => {
  return (
    <Date>
      <Span
        display="block"
        textTransform="uppercase"
        lineHeight={1}
      >
        { tsDate(timestamp, 'MMM') }
      </Span>
      <Span
        display="block"
        fontSize={38}
        lineHeight={1}
        marginBottom={2}
      >
        { tsDate(timestamp, 'D') }
      </Span>
      <Span
        display="block"
        color="rgb(173, 173, 173)"
      >
        { tsDate(timestamp, 'YYYY') }
      </Span>
    </Date>
  )
};

const DateRange = (props) => {
  return (
    <Div>
    <Range>
      {renderDate(props.leave)}
      <DateSep>
      <svg width="54" height="13" viewBox="0 0 54 13" xmlns="http://www.w3.org/2000/svg">
        <path d="M.5 5.5H51M46.5.55l4.95 4.95-4.95 4.95" stroke={color.BRAND_1} strokeWidth="2"  strokeLinecap="round" strokeLinejoin="round" fill="none"/>
      </svg>
      </DateSep>
      {renderDate(props.return)}
    </Range>
    <Div marginTop={8} css={{
      [dimensions.SCREEN_MAX_LG]: {
        textAlign: 'center'
      }
    }}>
      <Span>{tsDiff(props.leave, props.return)} Days</Span>
      {props.isFlexible
        ? <Span padding="3px 8px" borderRadius={15} marginLeft={14} backgroundColor="#122839" color="#fff">Flexible Dates</Span>
        : null
      }
    </Div>
  </Div>
  )
}

export default DateRange;



// WEBPACK FOOTER //
// ./src/components/pages/Trips/DateRange.jsx